import React from 'react';
import { ORDER_STATUS_LABELS, ORDER_STATUS_COLORS } from '../../types/models';

export const StatusBadge = ({ status, deliveryType, size = 'sm' }) => {
  let label = ORDER_STATUS_LABELS[status] || status;
  if (status === 'SHIPPED' && deliveryType === 'PICKUP') {
    label = 'Spakovana';
  }
  const colors = ORDER_STATUS_COLORS[status] || 'bg-muted text-muted-foreground border-border';
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 font-ui font-medium ${
      size === 'sm' ? 'text-xs' : 'text-sm'
    } ${colors}`}>
      {label}
    </span>
  );
};
